import React from 'react';

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="hero-grid" style={{ alignItems: 'flex-start' }}>
          <div className="about-content">
            <h2 className="about-title">The Legacy of <span>TTAB</span></h2>
            <p className="about-desc">
              The Table Tennis Association of Baroda (TTAB) has been the cornerstone of professional and amateur table tennis in the region. We are dedicated to fostering talent, promoting the sport, and hosting world-class events.
            </p>
            <p className="about-desc">
              Whether you are a seasoned professional or a passionate beginner, TTAB provides the platform, facilities, and competitive environment to take your game to the next level.
            </p>
          </div>
          
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">25+</div>
              <div className="stat-label">Years of Excellence</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">5K+</div>
              <div className="stat-label">Registered Players</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">50+</div>
              <div className="stat-label">Tournaments Hosted</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">10</div>
              <div className="stat-label">National Champions</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
